import groq from 'groq';

import { ASSET } from '../common';
import { productHref } from './productHref';
import { PRODUCT_SLUG } from './productSlug';

export const PRODUCT = groq`
  category,
  ${PRODUCT_SLUG},
  ${productHref()},
  "title": store.title,
  altTitle { title, subtitle },
  "priceRange": store.priceRange,
  shortDescription,
  "longDescription": pt::text(longDescription),
  "images": coalesce(thumbnails, images[_type == "image"])[0..1] {
    ${ASSET},
  },
  formatLabel,
  productBullet,
  secondaryProductBullet,
  infoBox,
  asin,
  "isPreorder": coalesce(isPreorder, false),
  "isTruemed": coalesce(isTruemed, false),
  "isMoneyBackGuarantee": coalesce(isMoneyBackGuarantee, false),
  "isDoctorRecommended": coalesce(isDoctorRecommended, false),
  "isNewPrice": coalesce(isNewPrice, false)
`;

export const PRODUCTS_IN_COLLECTION = groq`
  "products": collection -> {...}.products[].product -> {${PRODUCT_SLUG}}
`;

export const PRODUCT_COLLECTION = groq`
  name,
  "products": products[].product -> {${PRODUCT_SLUG}}
`;
